import {
  Box,
  Grid,
  SxProps,
  Theme,
  useMediaQuery as measureScreenWidth,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { belowLargeTablet } from "src/shared/components/responsiveHelpers";
import addStylesForDevices from "src/utils/addStylesForDevices";
import Authentication from "./Authentication.svg";

type Props = {
  corner?: React.ReactNode;
  children: React.ReactNode;
  variant?: "split" | "focused";
};

const cornerBaseStyles: SxProps<Theme> = {
  position: "absolute",
  top: (theme: Theme) => theme.spacing(4),
  display: "flex",
  justifyContent: "center",
};

export default function AuthenticationLayout({
  corner,
  children,
  variant = "split",
}: Props) {
  const isBelowLargeTablet = belowLargeTablet(measureScreenWidth);
  const gridContainerStyles = addStylesForDevices(
    isBelowLargeTablet,
    { backgroundColor: "#FF8F60" },
    { display: "none" }
  );
  const navigate = useNavigate();

  if (variant === "focused") {
    return (
      <Box
        sx={{
          minHeight: "100dvh",
          backgroundColor: "background.default",
          display: "flex",
          flexDirection: "column",
          overflowX: "clip",
        }}
      >
        {corner && (
          <Box
            component="button"
            type="button"
            aria-label="Go to home"
            onClick={() => navigate("/")}
            sx={{
              position: "absolute",
              top: { xs: 28, sm: 36 },
              left: "50%",
              transform: "translateX(-50%)",
              display: "grid",
              placeItems: "center",
              padding: 0,
              border: 0,
              background: "transparent",
              cursor: "pointer",
            }}
          >
            {corner}
          </Box>
        )}
        <Box
          component="main"
          sx={{
            width: "100%",
            maxWidth: 616,
            boxSizing: "border-box",
            marginX: "auto",
            paddingX: { xs: 3, sm: 4 },
            paddingTop: { xs: 15, sm: 17 },
            paddingBottom: { xs: 5, sm: 8 },
          }}
        >
          {children}
        </Box>
      </Box>
    );
  }

  return (
    <Grid container sx={{ height: 1 }}>
      {corner && !isBelowLargeTablet && (
        <Box
          sx={{
            ...cornerBaseStyles,
            left: (theme: Theme) => theme.spacing(4),
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        >
          {corner}
        </Box>
      )}
      <Grid item xs={11} sm={10} md={6} sx={{ marginX: "auto" }}>
        {corner && isBelowLargeTablet && (
          <Grid item xs={11} sx={cornerBaseStyles}>
            {corner}
          </Grid>
        )}
        <Grid sx={{ marginTop: { xs: 8, sm: 10 }, paddingY: 10 }}>
          {children}
        </Grid>
      </Grid>
      <Grid
        container
        item
        md={3}
        sx={gridContainerStyles}
        justifyContent="center"
        alignContent="center"
        minHeight={{ md: 766, xl: 700 }}
        maxHeight={1}
        overflow="hidden"
      >
        <img src={Authentication} alt="" width="100%" />
      </Grid>
    </Grid>
  );
}
